import React from 'react';
import AMultiFieldSearchInput from '../../components/AMultiFieldSearchInput/AMultiFieldSearchInput';
// import { searchInputOptions, statusFilterOptions } from '../components/searchStudent/studentTransfersListing/utils';
// import { searchInputOptions } from './constant';
// import { getFilterFormFields } from './constant';
import FilterForm from './FilterForm';
import AButton from '../../views/pages/manage/common/form-fields-mui/AButton';
import APopover from '../../views/pages/manage/common/a-popover';
import { ReactComponent as ExcelIcon } from "assets/img/svg/excel.svg";
import { getFilterFormFields, initialForm } from './constant';
// import { EMPTY_FILTER_FORM, getFilterFormFields } from './utils';

const Filters = ({
    dropdowns,
    getOutstandingList,
    loading,
    globalFilter,
    setGlobalFilter,
    searchInputOptions = {},
    tabKey,
    userPermissions
}) => {


    const searchHandler = (filters = {}) => {
        getOutstandingList({
            filters: { ...globalFilter, ...filters },
            pageNo: 0,
            tabKey
        })
    }



    return (
        <div className='d-flex align-items-center' style={{ gap: '0.75rem' }}>
            {/* <div style={{marginBottom: '1rem'}}> */}
            <AMultiFieldSearchInput
                options={searchInputOptions}
                isLoading={loading}
                searchHandler={(keyName, value) => searchHandler({ [keyName]: value || null })}
                crossHandler={(keyName, value) => searchHandler({ [keyName]: value || null })}
                displayType="horizontal"
            />
            {/* </div> */}

            <APopover
                buttonComponent={(openPopover, styles) => (
                    //  <div style={{marginBottom: '1rem'}}>
                    <AButton
                        className="tiny-semi-bold color-dark"
                        onClick={openPopover}
                        size="xs"
                        updatedStyle={{
                            minWidth: "61px",
                            ...(globalFilter?.appliedFilterCount > 0
                                ? {
                                    border: "1px solid #00B0F5",
                                    color: "#00B0F5",
                                }
                                : styles),
                        }}
                    >
                        Filters {globalFilter?.appliedFilterCount || ''}
                        {/* {filterCount > 0 ? `(${filterCount})` : ""} */}
                    </AButton>
                    // </div>
                )}
                menuComponent={(closePopup) =>
                    <FilterForm
                        closePopup={closePopup}
                        dropdownData={dropdowns}
                        globalFilter={globalFilter}
                        setGlobalFilter={setGlobalFilter}
                        searchHandler={searchHandler}
                        getFilterFormFields={getFilterFormFields}
                        initialForm={initialForm}
                        tabKey={tabKey}
                    />
                }
            />
            {(userPermissions||[]).includes('C') &&
            <AButton
                onClick={() => { }}
                variant='outline'
                outlineVariantColor='#CCC'
                textColor='#0F0F0F'
                size='xs'
                className='no-ml-btn'
            >
                <ExcelIcon className='mr-1' />
                Download CSV
            </AButton>
}

        </div>
    );
}

export default Filters;